import { ShipmentBranchSelect } from '@/views/screens/Shipment';
import FormInput from '../../../../components/Inputs/FormInput';
import TransportationProviderSelector from '../../../../components/Selectors/AsynchSearch/TransportationProviderSelector';
import LossAndDamageClaimStatusSelector from '../../../../components/Selectors/LossAndDamageClaimStatusSelector';

const BasicFilters = ({ filterForm }) => {
  return (
    <div className="px-15 h-100 custom-scroll-bar">
      <FormInput editMode label="Days Old" margin="mb-15" inputType="number" name="daysOld" />
      <LossAndDamageClaimStatusSelector editMode label="Status" margin="mb-15" name="claimStatus" mode="multiple" />
      <FormInput editMode label="Claim Number" margin="mb-15" name="claimNo" />
      <ShipmentBranchSelect editMode label="Branch" margin="mb-15" userType="CUST" name="branchKey" />
      <TransportationProviderSelector
        editMode
        label="Transportation Provider"
        margin="mb-15"
        name="carrierKey"
        form={filterForm}
      />
      <FormInput editMode label="Freight Bill / Pro Number" margin="mb-15" name="freightBillNo" />
      <FormInput editMode label="Invoice Number" margin="mb-15" name="invoiceNo" />
    </div>
  );
};

export default BasicFilters;
